const {jQuery: $} = window;
import Utils from "./utils.class";

export default class SlickSlider {
    #$locSlider;
    #utils;
    #chevron;

    constructor(utils) {
        this.#utils = utils;
        Utils.log("Slider Initialized");
        this.#$locSlider = $(".testimonial_slider__slider");
        this.#chevron = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.12 101.92"><g><path style="fill:#fff;" d="m0,4.74c0-1.1.31-2.2.93-3.09C2.32-.34,4.75-.56,6.36,1.15l43.49,46.21c1.7,1.8,1.7,5.39,0,7.19L6.37,100.77c-1.61,1.71-4.04,1.49-5.43-.5-1.39-1.99-1.2-4.99.4-6.69l40.1-42.63L1.34,8.34c-.88-.94-1.34-2.26-1.34-3.6Z"/></g></svg>`;
    }

    setup() {
        Utils.log("Slick Initialized");
        this.#$locSlider.slick({
            prevArrow: `<button type="button" class="slick-prev slick-custom-prev">${this.#chevron}</button>`,
            nextArrow: `<button type="button" class="slick-next slick-custom-next">${this.#chevron}</button>`,
            autoplay: true,
            autoplaySpeed: 7000,
            pauseOnFocus: true,
            pauseOnHover: true,
            autoHeight: "calc",
            responsive: [
                {
                    breakpoint: 650,
                    settings: {
                        autoplaySpeed: 2500,
                    }
                }
            ]
        });
    }


    show() {

    }
}